import React, { useState } from 'react'
import ky, { HTTPError } from 'lib/ky'
import { func, string } from 'prop-types'

export default function PrebookingCodeAuthorization (props) {
  const [state, setState] =
    useState({ value: props.value || '', errorMessage: null, working: false })

  const authorizationUrl = props.authorizationUrl
  const onSuccess = props.onSuccess

  return (
      <div className="prebooking_code_authorization">
        <div className="spinner_place">{renderSpinner(state)}</div>
        <div className="field_container">
          <label>
            Please Enter Your Pre-Booking Code To Proceed
            <input type="text" onChange={target => setState({ ...state, value: event.target.value })} value={state.value} />
          </label>
          {renderError(state)}
        </div>
        <button className="submit" onClick={() => submit({ state, authorizationUrl, setState, onSuccess })}>
          Click Here to Continue
        </button>
      </div>
  )
}

PrebookingCodeAuthorization.propTypes = {
  authorizationUrl: string.isRequired,
  onSuccess: func.isRequired,
  value: string
}

function renderError ({ errorMessage }) {
  if (errorMessage) {
    return <div className="error">{errorMessage}</div>
  } else {
    return null
  }
}

function renderSpinner ({ working }) {
  if (working) {
    return <div className="spinner">Loading...</div>
  } else {
    return null
  }
}

async function submit ({ authorizationUrl, state, setState, onSuccess }) {
  setState({ ...state, working: true })
  try {
    console.log(authorizationUrl, { json: { code: state.value } })
    const response = await ky.post(authorizationUrl, { json: { code: state.value } }).json()
    setState({ ...state, errorMessage: null, working: false, onSuccess: onSuccess({ prebooking: response.prebooking }) })
  } catch (e) {
    setState({ ...state, errorMessage: 'Something went wrong', working: false })
    if (e instanceof HTTPError) {
      const response = await e.response.json()
      if (response.errorMessage !== undefined) {
        setState({ ...state, errorMessage: response.errorMessage, working: false })
      } else {
        throw e
      }
    } else {
      throw e
    }
  }
}
